export default {
  path: "Message",
  component: () => import('@/views/AppMain/index'),
  name: "Message",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "消息管理",
    keepAlive: false,
    icon: '1002',
    activeIcon: '1001',
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
      {
        hidden: false,
        path: "NoticeManagement",
        component: () => import("@/views/HeadOfficeManagement/Marketing/NoticeManagement"),
        name: "NoticeManagement",
        meta: {
          title: "公告管理",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "ModelMessageManage",
        component: () => import("@/views/HeadOfficeManagement/Message/ModelMessageManage"),
        name: "ModelMessageManage",
        meta: {
          title: "消息模版管理",
          keepAlive: true,
        },
      }
  ]
};
